import { z } from "zod";

const tagGroups = ["group", "competence"] as const;
export const tagGroupsSchema = z.enum(tagGroups);
export type ITagGroup = z.infer<typeof tagGroupsSchema>;

/**
 * Schema for tag-related fields that should be excluded from template API payloads.
 * These fields are used for form state but should not be sent to the backend.
 */
const _templateTagFieldsSchema = z.object({
  groupId: z.string().nullish(),
  competenceTagsIds: z.array(z.string()).nullish(),
});

export type ITemplateTagFields = z.infer<typeof _templateTagFieldsSchema>;

type IBatchTemplateShape = { template: { activities: unknown } };

export const isBatchTemplate = <T extends { template: object }>(
  template: T,
): template is Extract<T, IBatchTemplateShape> =>
  "activities" in template.template;

export const isActivityTemplate = <T extends { template: object }>(
  template: T,
): template is Exclude<T, IBatchTemplateShape> => !isBatchTemplate(template);
